import { getSiteTypes, dropDown, postSiteTypes, targetSiteTypes, updateSiteTypes } from './interfaces'
import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL;

export const getSites = async (showDeleted: boolean): Promise<getSiteTypes[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get<getSiteTypes[]>(`https://${apiURL}/Sites?ShowDeleted=${showDeleted}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;

   const siteData: getSiteTypes[] = (data as getSiteTypes[]).map((item: getSiteTypes) => ({
      siteId: item.siteId,
      siteAddr: item.siteAddr,
      postcode: item.postcode,
      deletedDate: item.deletedDate,
      what3Words: item.what3Words,
   }));
   return siteData;
};

export const getSitesDropdown = async (searchTerm: string): Promise<dropDown[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }
   const response = await axios.get(`https://${apiURL}/Sites/ForDropdown?filter=${searchTerm}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;

   const siteDropdownData: dropDown[] = (data as dropDown[]).map((item: any) => ({
      value: item.value,
      text: item.text,
   }));

   return siteDropdownData;
};

export const getSitesForJobsFilterDropdown = async (searchTerm: string): Promise<dropDown[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }
   const response = await axios.get(`https://${apiURL}/Jobs/Sites/ForFilterDropdown?filter=${encodeURIComponent(searchTerm)}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;

   const siteDropdownData: dropDown[] = (data as dropDown[]).map((item: any) => ({
      value: item.value,
      text: item.text,
   }));

   return siteDropdownData;
};


export const submitSite = async (site: postSiteTypes) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Sites`,
      method: 'post',
      data: {
         siteAddr: site.siteAddr,
         postcode: site.postcode,
      },
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   })

   const data: postSiteTypes = response.data;
   return data;
};


export const getTargetSite = async (siteId: number): Promise<targetSiteTypes> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/Sites/${siteId}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data: targetSiteTypes = response.data;

   const targetSiteData: targetSiteTypes = {
      siteId: data.siteId,
      siteAddr: data.siteAddr,
      postcode: data.postcode,
      deletedDate: data.deletedDate,
   };

   return targetSiteData;
};


export const getMatchingClientSite = async (clientId: number) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/Sites/SiteClientMatch/${clientId}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;

   return data;
};


export const updateSite = async (site: updateSiteTypes, siteId: number) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Sites/${siteId}`,
      method: 'put',
      data: {
         siteId: siteId,
         siteAddr: site.siteAddr,
         postcode: site.postcode
      },
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   })

   const data: updateSiteTypes = response.data;
   return data;
};



export const deleteSite = async (siteId: number) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.delete(`https://${apiURL}/Sites/${siteId}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data: any = response.data;

   return data;
};